module.exports = __webpack_public_path__ + "img/banner.367d51e4.png";